import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'fullscreen-workout-theme';
const VALID_THEMES = ['dark', 'light'];

const useThemeToggle = (defaultTheme = 'dark') => {
    const [theme, setTheme] = useState(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        return VALID_THEMES.includes(stored) ? stored : defaultTheme;
    });

    useEffect(
        () => {
            localStorage.setItem(STORAGE_KEY, theme);
        },
        [theme]
    );

    const toggleTheme = useCallback(() => {
        setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
    }, []);

    return [theme, toggleTheme];
};

export default useThemeToggle;



// WEBPACK FOOTER //
// ./src/view/fullScreenWorkout/useThemeToggle.js